import React from "react";

import { PropsTypeSvg } from "@typings/global.types";

const CoinSvg = React.forwardRef<SVGSVGElement, PropsTypeSvg>(
  ({ classNameProps, width, height }, ref) => {
    return (
      <svg
        ref={ref}
        xmlns='http://www.w3.org/2000/svg'
        className={classNameProps}
        width={width}
        height={height}
        viewBox='0 0 30 30'
        fill='none'
      >
        <circle cx='15' cy='15' r='13.5' fill='#FFCC00' />
        <circle cx='15' cy='15' r='10.125' fill='#FF9500' />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M18.7985 12.6565C18.697 13.3266 18.0917 14.0663 16.933 14.0663H12.7407L13.1639 11.2687H17.354C18.5127 11.2687 18.8984 11.9875 18.7985 12.6565ZM12.3906 16.3879H15.8429L17.5059 20.4058C17.6671 20.8131 18.0229 21.0748 18.6635 21.0748C19.4757 21.0748 20.134 20.4775 20.2421 19.7592C20.2774 19.52 20.2399 19.2813 20.1439 19.0908L18.8644 15.9817C20.5848 15.3592 21.4836 14.1378 21.7032 12.6783C22.0172 10.6011 20.7906 8.9248 17.2654 8.9248H12.0385C11.2241 8.9248 10.461 9.56974 10.343 10.3592L8.94094 19.641C8.82287 20.4288 9.39118 21.0748 10.205 21.0748C11.0194 21.0748 11.7836 20.4288 11.9017 19.641L12.3906 16.3879Z'
          fill='#FFCC00'
        />
      </svg>
    );
  },
);

export default CoinSvg;
